/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Status_OpenInputs */

const en_manual_qc_status_open = /** @type {(inputs: Manual_Qc_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const fr_manual_qc_status_open = /** @type {(inputs: Manual_Qc_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvert`)
};

const de_manual_qc_status_open = /** @type {(inputs: Manual_Qc_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offen`)
};

const it_manual_qc_status_open = /** @type {(inputs: Manual_Qc_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprire`)
};

const ru_manual_qc_status_open = /** @type {(inputs: Manual_Qc_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть`)
};

const es_manual_qc_status_open = /** @type {(inputs: Manual_Qc_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abierto`)
};

const zh_cn2_manual_qc_status_open = /** @type {(inputs: Manual_Qc_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开`)
};

const ja_manual_qc_status_open = /** @type {(inputs: Manual_Qc_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開ける`)
};

const hi_manual_qc_status_open = /** @type {(inputs: Manual_Qc_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खुला`)
};

const pt_pt2_manual_qc_status_open = /** @type {(inputs: Manual_Qc_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Manual_Qc_Status_OpenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_status_open = /** @type {((inputs?: Manual_Qc_Status_OpenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Status_OpenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_status_open(inputs)
	if (locale === "de") return de_manual_qc_status_open(inputs)
	if (locale === "it") return it_manual_qc_status_open(inputs)
	if (locale === "ru") return ru_manual_qc_status_open(inputs)
	if (locale === "es") return es_manual_qc_status_open(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_status_open(inputs)
	if (locale === "ja") return ja_manual_qc_status_open(inputs)
	if (locale === "hi") return hi_manual_qc_status_open(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_status_open(inputs)
	return en_manual_qc_status_open(inputs)
});